import { render, staticRenderFns } from "./manage-dynamic-groups-page.vue?vue&type=template&id=2c6a5554&scoped=true"
import script from "./manage-dynamic-groups-page.vue?vue&type=script&lang=js"
export * from "./manage-dynamic-groups-page.vue?vue&type=script&lang=js"
import style0 from "./manage-dynamic-groups-page.vue?vue&type=style&index=0&id=2c6a5554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a5554",
  null
  
)

export default component.exports